module.exports = __webpack_public_path__ + "static/media/Editais-Online.b6121e58.png";